import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapRadarRoute extends Route {
  @service store;
  @service('current-user') currentUser;
  defaultStatus = ['ACTIVE', 'READY', 'READY FOR PLANNING', 'DISCOVERY'];

  queryParams = {
    status: {
      refreshModel: true,
    },
    sources: {
      refreshModel: true,
    },
    product_managers: {
      refreshModel: true,
    },
    themes: {
      refreshModel: true,
    },
    teams: {
      refreshModel: true,
    },
  };

  themes = [];

  beforeModel() {
    const promises = [
      this.store.findAll('theme'),
      this.store.findAll('person'),
      this.store.findAll('team'),
    ];
    return Promise.all(promises).then(([themes]) => {
      this.themes = themes;
    });
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.set('themeOptions', this.themes);
    if (controller.get('status').length === 0) {
      controller.set('status', this.defaultStatus);
    }
  }

  async model(params) {
    const _params = { ...params };
    delete _params['grouping'];
    if (_params.status.length === 0) _params.status = this.defaultStatus;
    const initiatives = this.store.query('initiative', _params);

    return {
      organisation: this.organisation.organisation,
      initiatives,
    };
  }
}

export default instrumentRoutePerformance(RoadmapRadarRoute);
